import { isKnownBrand } from "./brand";

const DEFAULT_TRAINING_BASE_URL =
  process.env.REACT_APP_ENV === "production" ? "https://training.lucashealth.ai" : "https://staging-training.lucashealth.ai";

const isOrdersPath = (path) =>
  path === "/orders" || path === "/ordersManagement" || path === "/onboarding" || path === "/dme-credentialing";

const isSharedAdminPath = (path) =>
  path === "/users" ||
  path.startsWith("/users/") ||
  path.startsWith("/settings") ||
  path === "/locations" ||
  path.startsWith("/locations/");

export const getTrainingBaseUrl = () => {
  return process.env.REACT_APP_TRAINING_URL || DEFAULT_TRAINING_BASE_URL;
};

export const isOrdersTrainingContext = ({ currentPath, previousPath, hasEncounters, hasOrders, hasOrdersManagement }) => {
  if (isOrdersPath(currentPath)) {
    return true;
  }

  const previousOrdersPath = isOrdersPath(previousPath || "");
  if (isSharedAdminPath(currentPath) && previousOrdersPath) {
    return true;
  }

  return !hasEncounters && (hasOrders || hasOrdersManagement);
};

export const buildTrainingUrl = ({ currentPath, previousPath, hasEncounters, hasOrders, hasOrdersManagement, brand }) => {
  const isOrdersTraining = isOrdersTrainingContext({
    currentPath,
    previousPath,
    hasEncounters,
    hasOrders,
    hasOrdersManagement,
  });
  const trainingPath = isOrdersTraining ? "/orders-training" : "";
  const trainingType = isOrdersTraining ? "orders" : "encounters";
  // Only a recognized brand is forwarded — junk/absent brands keep today's URL.
  const brandParam = isKnownBrand(brand) ? `&brand=${brand.toLowerCase()}` : "";

  return `${getTrainingBaseUrl()}${trainingPath}?from=app&type=${trainingType}${brandParam}`;
};
